import './i18n';
import { observer } from 'mobx-react-lite';
import { SnackbarProvider } from '@monorepo/nova-ui';
import { AppLoadingSpinner } from '@monorepo/react-components';
import { AppTitle } from './app-title';
import { useAppInitialization, useWindowOnError } from './hooks';
import { ThemeProvider } from './providers/theme-provider';
import RouterHandler from './routers/router-handler';
import { EnvService } from './services/core/env-service';

const { application } = EnvService;

interface AppProps {
  basename: string;
}

const App = ({ basename = 'en' }: AppProps) => {
  const { isAppLoading } = useAppInitialization();

  useWindowOnError();

  if (isAppLoading) {
    return <AppLoadingSpinner application={application} />;
  }

  return (
    <ThemeProvider>
      <SnackbarProvider>
        <AppTitle />
        <RouterHandler basename={`/${basename}`} />
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default observer(App);
